import type { ReactNode } from 'react';
import type { PreviewFormat } from './editor-types';

/**
 * Cadre d'aperçu : le contenu est rendu à la taille logique du format (appareil ou largeur de page) puis
 * réduit, pour que la mise en page soit celle de l'écran réel. Un format sans largeur rend sans cadre.
 * Un seul moteur de rendu : celui que le métier fournit.
 */
export function DeviceFrame({ format, children }: { format: PreviewFormat; children: ReactNode }) {
  if (format.width === undefined || format.height === undefined) return <div className="ay-device ay-device--fluid">{children}</div>;
  const scale = format.scale ?? 1;
  return (
    <div className="ay-device" style={{ width: format.width * scale + 20, height: format.height * scale + 20 }} data-format={format.id}>
      <div className="ay-device__screen" style={{ width: format.width, height: format.height, transform: `scale(${scale})` }}>
        {children}
      </div>
    </div>
  );
}

/** Appareil pivoté : largeur et hauteur échangées, orientation inversée ; sans orientation, inchangé. */
export function rotated(format: PreviewFormat): PreviewFormat {
  if (format.orientation === undefined || format.width === undefined || format.height === undefined) return format;
  return { ...format, width: format.height, height: format.width, orientation: format.orientation === 'landscape' ? 'portrait' : 'landscape' };
}

/** Marge de l'aperçu « Ajuster » : le cadre de l'appareil (20 px) et le jeu autour (24 px). */
const FIT_MARGIN = 44;

/**
 * Échelle « Ajuster » : l'appareil prend la largeur et la hauteur disponibles du canevas, proportions gardées,
 * entre 20 % et 200 %. Un format sans taille, ou une place encore inconnue, se rend à 100 %.
 */
export function fitScale(format: PreviewFormat, stage: { width: number; height: number } | null): number {
  if (format.width === undefined || format.height === undefined || stage === null || stage.width <= 0 || stage.height <= 0) return 1;
  return Math.max(0.2, Math.min(2, (stage.width - FIT_MARGIN) / format.width, (stage.height - FIT_MARGIN) / format.height));
}
